export const LEGACY_SLIDE_LIMITS = Object.freeze({
  rules: [
    {
      id: '5-quiz-legacy', label: 'Quiz', match: { type: ['pickAnswer'] }, limit: 5,
    },
    {
      id: '3-unscored-legacy',
      label: 'Unscored',
      match: { type: ['multipleChoice', 'imageChoice', 'openEnded', 'wordCloud', 'ideas', 'scale', 'pinOnImage', 'ideaBoard', 'ranking'] },
      limit: 3,
    },
  ],
  default: false,
})

const MATCH_FIELDS = ['type', 'slideType']

const _isValidLimit = (value) => value === false || (Number.isInteger(value) && value >= 0)

const _isValidMatch = (match) => {
  if (!match || typeof match !== 'object' || Array.isArray(match)) return false
  const keys = Object.keys(match)
  if (keys.length === 0) return false
  return keys.every((key) => MATCH_FIELDS.includes(key)
    && Array.isArray(match[key])
    && match[key].length > 0
    && match[key].every((entry) => typeof entry === 'string'))
}

/**
 * Returns true if value is a well-formed slideLimits object.
 * @param {*} value
 * @returns {boolean}
 */
export const isValidSlideLimits = (value) => {
  if (!value || typeof value !== 'object') return false
  if (!Array.isArray(value.rules)) return false
  if (!_isValidLimit(value.default)) return false
  return value.rules.every((rule) => rule
    && typeof rule.id === 'string'
    && rule.id.length > 0
    && _isValidMatch(rule.match)
    && _isValidLimit(rule.limit)
    && (rule.label === undefined || typeof rule.label === 'string'))
}

/**
 * Returns maybe if valid, otherwise falls back to LEGACY_SLIDE_LIMITS.
 * @param {*} maybe
 * @returns {Object}
 */
export const resolveSlideLimits = (maybe) => (isValidSlideLimits(maybe) ? maybe : LEGACY_SLIDE_LIMITS)
